export default [
    {
        method: 'getBanner',
        type: 'GET',
        path: '/home/banner',
        mode: 'web',
        params: [],
        options: { cache: false, },
        switch: true,
    },
    {
        method: 'getGameList',
        type: 'GET',
        path: '/home/game/recommend',
        mode: 'web',
        params: [],
        options: { cache: false, },
        switch: true,
    },
    {
        method: 'getNewsTop',
        type: 'GET',
        path: '/news/top',
        mode: 'web',
        params: [],
        options: { cache: false, },
        switch: true,
    },
    {
        method: 'getNewsList',
        type: 'GET',
        path: '/news/page',
        mode: 'web',
        params: ["page_num", "page_size"],
        options: { cache: false, },
        switch: true,
    },
    {
        method: 'getEventsList',
        type: 'GET',
        path: '/activity/page',
        mode: 'web',
        params: ["page_num", "page_size"],
        options: { cache: false, },
        switch: true,
    },
    {
        method: 'getNewsDetail',
        type: 'GET',
        path: '/news/detail',
        mode: 'web',
        params: ["news_id"],
        options: { cache: false, },
        switch: true,
    },
    {
        method: 'getEventDetail',
        type: 'GET',
        path: '/activity/detail',
        mode: 'web',
        params: ["activity_id"],
        options: { cache: false, },
        switch: true,
    },
    {
        method: 'previewNewsDetail',
        type: 'GET',
        path: '/news/detail',
        mode: 'web',
        params: ["news_id"],
        options: { cache: false, },
        switch: true,
    },
    {
        method: 'previewEventDetail',
        type: 'GET',
        path: '/activity/detail',
        mode: 'web',
        params: ["activity_id"],
        options: { cache: false, },
        switch: true,
    },
    {
        method: 'getModuleList',
        type: 'GET',
        path: '/home/module/list',
        mode: 'web',
        params: [],
        options: { cache: false, },
        switch: true,
    },
];